import { render, staticRenderFns } from "./ItemSummaryList.vue?vue&type=template&id=5babddf3&scoped=true"
import script from "./ItemSummaryList.vue?vue&type=script&lang=js"
export * from "./ItemSummaryList.vue?vue&type=script&lang=js"
import style0 from "./ItemSummaryList.vue?vue&type=style&index=0&id=5babddf3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5babddf3",
  null
  
)

export default component.exports